import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap'
import { formatErrorResponse } from '../utils/errorHandlers'
import { locationAPI } from '../api/locationAPI'

function LocationUpdateScreen() {
    const { id } = useParams()
    const { state } = useLocation();
    const warehouseId = state?.warehouseId;
    const navigate = useNavigate()
    const [error, setError] = useState(null)
    const [location, setLocation] = useState({
        name: '',
        description: '',
        warehouse: warehouseId,
        is_active: true
    })

    useEffect(() => {
        async function fetchLocation() {
            try {
                const data = await locationAPI.getById(id);
                setLocation(data)
            } catch (error) {
                console.error('Error fetching location:', error)
                setError('Failed to load location data')
            }
        }
        fetchLocation()
    }, [id])

    const submitHandler = async (e) => {
        e.preventDefault()
        try {
            await locationAPI.update(id, location);
            navigate(-1)
        } catch (error) {
            setError(formatErrorResponse(error))
        }
    }

    const handleToggleActive = async (e) => {
        e.preventDefault();
        
        if (location.is_active) {
            if (!window.confirm('Are you sure you want to deactivate this location?')) {
                return;
            }
        }

        try {
            const updatedLocation = {
                ...location,
                is_active: !location.is_active
            };
            
            await locationAPI.update(id, updatedLocation);
            setLocation(updatedLocation);
        } catch (error) {
            console.error('Error toggling location status:', error);
            alert(`Failed to update location: ${error.response?.data?.message || error.message}`);
        }
    };

    return (
        <Container>
            <Row className="justify-content-left">
                <Col md={8} lg={6}>
                    <h1>Update Location</h1>
                    <Form onSubmit={submitHandler}>
                        <Form.Group className="mb-4" controlId="name">
                            <Form.Label>Name*</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter name"
                                value={location.name}
                                onChange={(e) => setLocation({ ...location, name: e.target.value })}
                                disabled={!location.is_active}
                                style={{ opacity: location.is_active ? 1 : 0.6 }}
                                required
                                autoComplete="off"
                                spellCheck="false"
                            />
                        </Form.Group>

                        <Form.Group className="mb-4" controlId="description">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter description"
                                value={location.description}
                                onChange={(e) => setLocation({ ...location, description: e.target.value })}
                                disabled={!location.is_active}
                                style={{ opacity: location.is_active ? 1 : 0.6 }}
                                autoComplete="off"
                                spellCheck="false"
                            />
                        </Form.Group>
                        {error && (
                            <Alert variant="danger" onClose={() => setError(null)} dismissible>
                                {error}
                            </Alert>
                        )}

                        <Row className="mt-3">
                            <Col>
                                {location.is_active ? (
                                    <>
                                        <Button 
                                            variant="primary" 
                                            type="submit" 
                                            className="me-2"
                                        >
                                            Update
                                        </Button>
                                        <Button 
                                            variant="danger"
                                            onClick={handleToggleActive}
                                            className="me-2"
                                        >
                                            Deactivate
                                        </Button>
                                        <Button 
                                            variant="secondary" 
                                            onClick={() => navigate(-1)}
                                        >
                                            Cancel
                                        </Button>
                                    </>
                                ) : (
                                    <Button 
                                        variant="success"
                                        onClick={handleToggleActive}
                                    >
                                        Activate
                                    </Button>
                                )}
                            </Col>
                        </Row>

                        {!location.is_active && (
                            <Alert variant="warning" className="mt-3">
                                This location is currently inactive. Activate it to make changes.
                            </Alert>
                        )}
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}

export default LocationUpdateScreen 